import { Eye } from "lucide-react";
import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import type { StockMovementWithArticle } from "@/hooks/queries/useStockMovements";
import { formatDateTime, formatMovementReference } from "./stock-formatters";
import { StockMovementBadge } from "./components/StockBadges";

export function createStockMovementColumns(
  onSelect: (movement: StockMovementWithArticle) => void,
): ColumnDef<StockMovementWithArticle, any>[] {
  return [
    {
      id: "article",
      header: "Article",
      cell: ({ row }) => (
        <div>
          <p className="text-[12px] font-medium text-body">
            {row.original.article?.name ?? `Article #${row.original.articleId}`}
          </p>
          <p className="text-[10.5px] text-muted-foreground">
            Mouvement #{row.original.id} - agent #{row.original.agentId}
          </p>
        </div>
      ),
    },
    {
      accessorKey: "type",
      header: "Type",
      cell: ({ row }) => <StockMovementBadge type={row.original.type} />,
    },
    {
      accessorKey: "quantity",
      header: "Quantité",
      meta: { align: "right" },
      cell: ({ row }) => (
        <span className="text-[12px] font-medium tabular-nums text-body">
          {row.original.quantity} {row.original.article?.unit ?? ""}
        </span>
      ),
    },
    {
      id: "reference",
      header: "Référence",
      cell: ({ row }) => (
        <span className="text-[12px] text-muted-foreground">
          {formatMovementReference(row.original)}
        </span>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "Date",
      cell: ({ row }) => (
        <span className="text-[12px] text-muted-foreground">
          {formatDateTime(row.original.createdAt)}
        </span>
      ),
    },
    {
      id: "detail",
      header: "",
      meta: { align: "right" },
      cell: ({ row }) => (
        <Button
          variant="ghost"
          size="icon"
          title="Voir le détail"
          onClick={(event) => {
            event.stopPropagation();
            onSelect(row.original);
          }}
        >
          <Eye size={13} />
        </Button>
      ),
    },
  ];
}
